import React from 'react';
import { Link } from 'react-router-dom';
import '../../btnTemplate.css';

function ButtonSignInHome () {

    return (
        <Link to='#'><button className='btn-primary'>Sign In</button></Link>
    )
}

export default ButtonSignInHome;